import React from 'react';
import './App.css';
import {wrapper} from './state/store';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { persistedstore } from './state/PersistedStore';
import { Provider } from 'react-redux';
import Loading from './components/Loading';
import AppSnackbar from './components/SnackBar/Snackbar';
import Box from '@mui/material/Box';
import Theme from './components/Theming/Theme';
import MyTransition from './components/Theming/MyTransition';
import FrontPage from './pages/FrontPage';
import SinglePlayer from './pages/SinglePlayer';
import SCTeams from './pages/scteams';
import SinglePosition from './pages/SinglePosition';
import SingleTeam from './pages/SingleTeam';
import SingleSCTeam from './pages/SingleSCTeam';
import SingleMatch from './pages/SingleMatch';
import SearchScreen from './pages/SearchScreen';
import ComparePlayers from './pages/ComparePlayers';
import FindPlayers from './pages/FindPlayers';
import ReactGA from 'react-ga4';
import {
  BrowserRouter as Router,
  Route,
  Routes
} from 'react-router-dom';

function App() {
  ReactGA.initialize("G-9ZNQBYR325");

  return (
    <div className="app">
      <div style={{minHeight: "80vh"}}>
      <Router>
        <Theme>
          {/* <MyTransition location={'/'}>                     */}
          
        
          {/* <SelectedPlayersContainer /> */}
          <AppSnackbar />
          <Routes>
              <Route path='/' element={<FrontPage />} />
              <Route path='/player/:id' element={<SinglePlayer />} />
              <Route path='/scteams' element={<SCTeams />} />
              <Route path='/position/:name' element={<SinglePosition />}/>
              <Route path='/team/:name' element={<SingleTeam />}/>
              <Route path='/scteam/:teamid' element={<SingleSCTeam />} />
              <Route path='/match/:matchId' element={<SingleMatch type="matchid" />}/>
              <Route path='/match/:season/:round/:team' element={<SingleMatch type="seasonround" />} />
              <Route path='/search' element={<SearchScreen />} />
              <Route path='/compareplayers' element={<ComparePlayers />} />
              <Route path='/findplayers' element={<FindPlayers />} />
              {/*
                <Route path='/tools/:tool' element={<Tools />} /> 
               */}
            </Routes>
            {/* </MyTransition> */}
        </Theme>
        </Router>
      </div>
    </div>
  );
}

export default App;
